// Area / perimeter / length readouts. Plan units are centimetres (1 unit = 1 cm). Curved
// polygons and lines are flattened before measuring, so the numbers match the
// shape on screen rather than its straight-chord approximation.

import { pathArea, pathLength, pathSegments, sampleSegment } from './segments';

export function elementArea(el) {
  const d = el.data || {};
  if (el.type === 'ellipse') { const r = (d.width || 0) / 2; return Math.PI * r * r; }
  if (el.type === 'rectangle') return (d.width || 0) * (d.height || 0);
  if (el.type === 'polygon') return pathArea(d.coordinates || []);
  return 0;
}

// Outline length of a closed shape: a circle's circumference, a rectangle's
// four sides, a polygon's path (curves followed). 0 for lines and images.
export function elementPerimeter(el) {
  const d = el.data || {};
  if (el.type === 'ellipse') return Math.PI * (d.width || 0);
  if (el.type === 'rectangle') return 2 * ((d.width || 0) + (d.height || 0));
  if (el.type === 'polygon') return pathLength(d.coordinates || [], true);
  return 0;
}

export function elementLength(el) {
  const d = el.data || {};
  if (el.type !== 'line') return 0;
  return pathLength(d.coordinates || [], false);
}

// Length of each polygon/line segment, in path order (a closed polygon's
// implicit closing edge included) — curves measured along the curve.
export function segmentLengths(el) {
  if (el.type !== 'polygon' && el.type !== 'line') return [];
  return pathSegments(el.data?.coordinates || [], el.type === 'polygon').map((seg) => {
    let prev = seg.from; let len = 0;
    for (const pt of sampleSegment(seg)) { len += Math.hypot(pt[0] - prev[0], pt[1] - prev[1]); prev = pt; }
    return len;
  });
}

export function formatLength(cm, units) {
  return units === 'imperial' ? `${(cm / 30.48).toFixed(2)} ft` : `${(cm / 100).toFixed(2)} m`;
}

export function formatArea(cm2, units) {
  return units === 'imperial' ? `${(cm2 / 929.0304).toFixed(2)} ft²` : `${(cm2 / 10000).toFixed(2)} m²`;
}

export function measureText(el, units) {
  const area = (cm2) => `Area ${formatArea(cm2, units)}`;
  const length = (cm) => `Length ${formatLength(cm, units)}`;
  if (el.type === 'line') {
    const len = elementLength(el);
    return len > 0 ? length(len) : '';
  }
  const a = elementArea(el);
  if (!(a > 0)) return '';
  if (el.type === 'polygon') return `${area(a)} · Perimeter ${formatLength(pathLength(el.data?.coordinates || [], true), units)}`;
  return area(a);
}
